import { kebabCase, find } from 'lodash';
import { assetUrl } from '~/helpers';
import { TestimonialListResponse } from '~/types/api/testimonials';
import { Media, Transcript } from '~/types/models';
import { Tag } from '~/types/models/tags';
import {
  Testimonial,
  ResourceTag,
  UserTagType,
} from '~/types/models/testimonial';

export const projectsUrl = '/projects';
export const publishUrl = '/publish';

export function getLandingPageUrl(
  testimonial: TestimonialListResponse | Testimonial,
  customDomain?: string
): string {
  const name = kebabCase(testimonial.name);
  const domain = customDomain
    ? `https://${customDomain}`
    : window.location.origin;
  return `${domain}/te/${name}/${testimonial.uuid}`;
}

/**
 * TODO: https://bonjoro.atlassian.net/browse/BJ-2842
 * Remove on FE integration as we may not need this anymore.
 */
export function getUserTag(
  tag: UserTagType,
  defaultTags?: Tag[]
): Tag | undefined {
  if (!defaultTags) return;

  return find(defaultTags, (defaultTag) => {
    return defaultTag.name == tag;
  });
}

export function getResourceTag(
  tag: Tag,
  responseTags: ResourceTag[]
): ResourceTag | undefined {
  return find(responseTags, (responseTag) => {
    return responseTag.tag?.uuid === tag.uuid;
  });
}

export const publishHelpDocLink =
  'https://help.bonjoro.com/en/articles/6078172-publish-your-testimonials';

export const getTestimonialLogoUrl = (
  hideBonjoroLogo: boolean,
  landingPageLogo: Media | null
) => {
  if (landingPageLogo?.id && landingPageLogo?.url) {
    return landingPageLogo.url;
  }

  //if team has no hide bonjoro logo feature, show bonjoro logo
  if (!hideBonjoroLogo) {
    return assetUrl('/assets/images/logos/logo_full.png');
  }

  return null;
};

export const stringifyTranscript = (transcript: Transcript) => {
  const textArray = transcript?.captions?.sentences?.map(
    (sentence) => sentence.text
  );

  return textArray?.join('\r\n\r\n');
};
